module.exports = __webpack_public_path__ + "images/areamap/btn_mappin_kansai_sp_0c2e8c37cf3b58c932779725a603c5b4.png";